import React, { useState } from 'react';
import './Studio.css';
import Header from '../../components/header/header';

const posts = [
  {
    id: 1,
    imageUrl: require('../../assets/studio/1.png'),
  },
  {
    id: 2,
    imageUrl: require('../../assets/studio/2.png'),
  },
  {
    id: 3,
    imageUrl: require('../../assets/studio/3.png'),
  },
  
  {
    id: 4,
    imageUrl: require('../../assets/studio/4.png'),
  },

  {
    id: 5,
    imageUrl: require('../../assets/studio/5.png'),
  },
  {
    id: 6,
    imageUrl: require('../../assets/studio/6.png'),
  },
  {
    id: 7,
    imageUrl: require('../../assets/studio/7.png'),
  },
  {
    id: 8,
    imageUrl: require('../../assets/studio/8.png'),
  },
  {
    id: 9,
    imageUrl: require('../../assets/studio/9.png'),
  },
  {
    id: 10,
    imageUrl: require('../../assets/studio/10.png'),
  },
  {
    id: 11,
    imageUrl: require('../../assets/studio/11.png'),
  },
  // Add more posts as needed
];

function Studio() {
    const [selectedImage, setSelectedImage] = useState(null);
  
    const openModal = (imageUrl) => {
      setSelectedImage(imageUrl);
    };
  
    const closeModal = () => {
      setSelectedImage(null);
    };
  
  return (
    <div className="portfolio-container">
      <Header />
      <div className="post-grid">
        {posts.map((post) => (
          <div className="post-card" key={post.id} onClick={() => openModal(post.imageUrl)}>
            <img src={post.imageUrl} alt={`Post ${post.id}`} />
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full Size" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Studio;
